
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";
import { RadioGroup } from "@/components/ui/radio-group";
import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';
import RadioFrequencyOption from './RadioFrequencyOption';

export const frequencyOptions = [
  { value: "Always", label: "Always" },
  { value: "Most of the time", label: "Most of the time" },
  { value: "Sometimes", label: "Sometimes" },
  { value: "Rarely", label: "Rarely" },
  { value: "Never", label: "Never" }
];

interface SleepQuestion {
  id: string;
  question: string;
}

interface SleepQuestionFieldProps {
  form: UseFormReturn<any>;
  question: SleepQuestion;
}

const SleepQuestionField: React.FC<SleepQuestionFieldProps> = ({ form, question }) => {
  return (
    <FormField
      key={question.id}
      control={form.control}
      name={question.id}
      render={({ field }) => (
        <FormItem className="border rounded-lg p-4 hover:bg-muted/10 transition-colors">
          <FormLabel className="text-base mb-2 block">{question.question}</FormLabel>
          <FormControl>
            <RadioGroup
              onValueChange={field.onChange}
              defaultValue={field.value}
              className="flex flex-wrap gap-2"
            >
              {frequencyOptions.map((option) => (
                <RadioFrequencyOption 
                  key={option.value}
                  questionId={question.id}
                  value={option.value}
                  label={option.label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default SleepQuestionField;
